import { render, staticRenderFns } from "./TermsPage.vue?vue&type=template&id=f3a65546&scoped=true"
import script from "./TermsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TermsPage.vue?vue&type=style&index=0&id=f3a65546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a65546",
  null
  
)

export default component.exports